import {useEffect} from 'react';
import Loading from '../../common/component/Loading';
import PageContainer from '../../common/component/PageContainer';
import {pAlert} from '../../common/component/PAlert';
import useLogin from '../../common/hook/useLogin';
import useTypedSelector from '../../common/hook/useTypedSelector';
import {useFetchInfo} from '../../common/util/fetch';
import {routeBack} from '../../common/util/PageRouter';
import {sendExtra} from '../../common/util/tracking';
import useSetBodyColor from '../../commonSub/hook/useSetBodyColor';
import {EventCommonContext} from '../common';
import EventModuleListV4 from '../component/EventModuleListV4';
import useEventPageEvent from '../hook/useEventPageEvent';
import useFetchModuleMap from '../hook/useFetchModuleMap';
import useGradientStyle from '../hook/useGradientStyle';
import {ActionType} from '../state/action';

interface Props {
  eventId: number;
}

export default function Event({eventId}: Props) {
  const moduleMap = useTypedSelector(state => state.event.moduleMap.event);
  const {isLoginChecking} = useLogin();
  const {isFetched} = useFetchInfo(ActionType.FetchEventModuleMap);
  const {bgColor, isExpired, questCampaignId} = moduleMap?.commonModule ?? {};
  const gradientStyle = useGradientStyle(bgColor);
  const sendEventPageEvent = useEventPageEvent();

  const handleClickBack = () => {
    sendEventPageEvent({
      actionName: 'close',
      customProps: {
        event_layer: 'header',
      },
    });
    routeBack();
  };

  useFetchModuleMap({
    id: eventId,
    eventType: 'event',
  });

  useEffect(() => {
    isExpired &&
      pAlert({
        title: t => t('error_event_expired_popup'),
        isForced: true,
      }).then(({okClicked}) => {
        okClicked && routeBack();
      });
  }, [isExpired]);

  useEffect(() => {
    // TODO: isExpired 조건을 봐야하는지 확인 필요.
    questCampaignId &&
      sendExtra({
        section: 'event_page',
        page: 'event_page',
        actionName: 'event_page',
        customProps: {
          quest_campaign_id: questCampaignId,
        },
      });
  }, [questCampaignId]);

  useSetBodyColor(bgColor);

  if (isLoginChecking || !isFetched) {
    return <Loading isFull />;
  }

  return (
    <PageContainer
      gradientStyle={gradientStyle}
      hasTopSpace={false}
      isOnlyDarkMode={true}
      onClickHeaderButton={handleClickBack}
      wrapperClassName="!bg-transparent"
    >
      <EventCommonContext.Provider
        value={{
          eventType: 'event',
          questCampaignId,
          eventId,
          bgColor,
        }}
      >
        <EventModuleListV4 {...moduleMap} />
      </EventCommonContext.Provider>
    </PageContainer>
  );
}
